import styled from 'styled-components'

import { bowtieTheme } from '../../../../../utils/constants'

export const ConsequenceThreatContainer = styled.div`
    width: 100%;
    height: 100%;

    .header {
        position: relative;
        padding: 16px;
        padding-bottom: 0px;

        .header-title {
            font-size: 12px;
            font-family: var(--font-semibold);
            color: var(--gray-800);
        }

        .header-subtitle {
            color: var(--gray-700);
        }

        .header-error-alert {
            position: absolute;
            height: 36px;
            width: 36px;
            top: calc(50% + 8px);
            transform: translateY(-50%);
            right: 16px;
            border: none;
            border-radius: 3px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: transparent;
            font-size: 16px;

            > i.has-errors {
                color: ${({ theme }) => theme['red-500']};
            }

            :hover {
                background: ${({ theme }) => theme['gray-100']};
            }
        }
    }

    .row-div {
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        padding: 16px;

        #sort-button {
            background: none;
            height: 36px;
            border-radius: 4px;
            border: 1px solid var(--gray-400);
            margin-left: 8px;

            > * {
                margin: 0;
                padding: 0;
            }

            span.caret {
                display: none !important;
            }

            i {
                color: var(--blue-500);
            }
        }
    }

    .type-bar {
        background-color: var(--gray-200);
        padding: 8px;
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: center;

        div {
            cursor: pointer;
            color: var(--gray-1000);
            font-size: 11px;
            padding-left: 8px;
            padding-right: 8px;

            &:not(:last-child) {
                border-right: 1px solid var(--gray-1000);
            }

            &.active {
                font-family: var(--font-bold);
            }
        }
    }

    .consequence-threat-list {
        height: calc(100% - 34px - 68px - 52px);
        padding: 16px;

        .ScrollbarsCustom-Track.ScrollbarsCustom-TrackY {
            right: -5px !important;
        }

        .custom-card {
            padding: 0px;
            border: none;
            margin-bottom: 4px;
            position: relative;

            &:hover {
                background-color: var(--blue-200);
                .delete-button {
                    opacity: 1;
                }
            }

            header {
                display: none;
            }

            .main-row {
                display: flex;
                flex-direction: row;
            }

            .main-col {
                display: flex;
                flex-direction: column;

                &.info {
                    flex-grow: 1;
                    border: 1px solid var(--gray-400);
                    border-radius: 0px 3px 3px 0px;
                    cursor: pointer;
                }
            }

            .row-card {
                display: flex;
                flex-direction: row;
                flex-grow: 1;
                padding-left: 8px;
                padding-right: 8px;
                padding-bottom: 2px;
                padding-top: 8px;

                .title {
                    color: var(--gray-900);
                    font-family: var(--font-bold);
                }

                .id {
                    color: var(--gray-700);
                    margin-left: 4px;
                }
            }
            .card-description {
                padding-left: 8px;
                padding-right: 8px;
                padding-bottom: 8px;
                padding-top: 2px;
                display: flex;
                flex-direction: row;
                color: var(--gray-700);
                font-size: 12px;
            }

            .custom-card-border {
                border-radius: 3px 0px 0px 3px;

                &.hazard {
                    width: 8px;
                    background: repeating-linear-gradient(45deg, #000000 0px, #000000 5px, #ffe600 5px, #ffe600 10px);
                }

                &.topevent {
                    border-left: 8px solid ${bowtieTheme.topEvent.topEventBackgroundColor};
                }

                &.threat {
                    border-left: 8px solid #3866b1;
                }

                &.consequence {
                    border-left: 8px solid #8768a3;
                }
            }
            .delete-button {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: 8px;
                /* background-color: red; */
                cursor: pointer;
                opacity: 0;
                i {
                    color: var(--red-700);
                    font-size: 14px;
                }
            }
        }
    }
`
